import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PackageBookingFooterControlsProps {
    submitDisabled: boolean;
    onDiscard: () => void;
}

const PackageBookingFooterControls = ({
    submitDisabled,
    onDiscard,
}: PackageBookingFooterControlsProps) => {
    const { t } = useTranslation('product');

    return (
        <Stack direction="row" mt={2} gap={1}>
            <Button
                variant="contained"
                color="neutral"
                sx={{ flexGrow: 1 }}
                onClick={onDiscard}
            >
                {t('Discard')}
            </Button>
            <Button
                variant="contained"
                color="secondary"
                sx={{ flexGrow: 2 }}
                disabled={submitDisabled}
                type="submit"
                data-draft
            >
                {t('Save as Draft')}
            </Button>
            <Button
                variant="contained"
                color="secondary"
                sx={{ flexGrow: 1 }}
                disabled={submitDisabled}
                type="submit"
            >
                {t('Confirm')}
            </Button>
        </Stack>
    );
};

export { PackageBookingFooterControls };
